import toast from 'react-hot-toast';

export default toast;